import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

interface CleviaGuideContextValue {
  isOpen: boolean;
  openGuide: () => void;
  closeGuide: () => void;
}

const CleviaGuideContext = createContext<CleviaGuideContextValue | undefined>(undefined);

export function CleviaGuideProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const value = useMemo(
    () => ({
      isOpen,
      openGuide: () => setIsOpen(true),
      closeGuide: () => setIsOpen(false),
    }),
    [isOpen]
  );

  return <CleviaGuideContext.Provider value={value}>{children}</CleviaGuideContext.Provider>;
}

export function useCleviaGuide() {
  const context = useContext(CleviaGuideContext);
  if (!context) throw new Error('useCleviaGuide must be used within CleviaGuideProvider');
  return context;
}
